import InsightDashboard from './InsightDashboardContainer';
import InsightDashboardView from './InsightDashboard';

export default InsightDashboard;
export { InsightDashboardView };
